import { Routes } from '@angular/router';
import { ElementAdminComponent } from './components/element-admin/element-admin.component';

export const ELEMENT_ROUTES: Routes = [{
	path: 'Element', component: ElementAdminComponent
}];
